import { useEffect } from 'react';
import { useAuthStore } from '@/store';
import { takeDiscoveryContinuation } from '@/lib/discoveryContinuation';
export default function useDiscoveryContinuation({ id, ready, onSend, onError }) {
  const userId = useAuthStore(s => s.user?.id);
  const session = useAuthStore(s => s._sessionGeneration);
  useEffect(() => {
    if (!ready || !userId) return;
    const prompt = takeDiscoveryContinuation({ conversationId: id, userId, session });
    if (prompt) Promise.resolve().then(() => onSend(prompt)).catch(onError);
  }, [id, ready, userId, session, onSend, onError]);
}
